import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlightPipe } from '@app/pipes/highlight/highlight.pipe';
import { TimezoneAbbrPipe } from '@app/pipes/timezone-abbr.pipe';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { EudsModalModule, EudsButtonModule, EudsToggleModule, EudsTagModule, EudsFilterModule } from '@eucoms/common-components/design-system';
import { DrawerComponent } from '../components/drawer/drawer.component';

@NgModule({
  declarations: [
    HighlightPipe,
    TimezoneAbbrPipe,
    ConfirmModalComponent,
    DrawerComponent
  ],
  imports: [
    CommonModule,
    EudsModalModule,
    EudsButtonModule,
    EudsToggleModule,
    EudsTagModule,
    EudsFilterModule
  ],
  exports: [
    HighlightPipe,
    TimezoneAbbrPipe,
    EudsModalModule,
    EudsButtonModule,
    EudsToggleModule,
    EudsTagModule,
    ConfirmModalComponent,
    DrawerComponent,
    EudsFilterModule
  ]
})
export class SharedModule { }
